import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("Bro_Company_Dash_User_Id"),
        companyId: localStorage.getItem("Bro_Company_Dash_Company_Id"),
        token: localStorage.getItem("Bro_Company_Dash_Token"),
        usertype: localStorage.getItem("Bro_Company_Dash_User_Type"),
        name: localStorage.getItem("Bro_Company_Dash_User_name"),
        image: localStorage.getItem("Bro_Company_Dash_userImg"),
        phone: localStorage.getItem("Bro_Company_Dash_userPhone"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
